var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('projects-section',{key:_vm.updateKey,attrs:{"projects":_vm.projects},on:{"setPage":_vm.getProjects,"openProjectDialog":_vm.openProjectDialog}}),_c('project-dialog',{attrs:{"project-id":_vm.selectedProject},model:{value:(_vm.projectDialog),callback:function ($$v) {_vm.projectDialog=$$v},expression:"projectDialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }